// @flow
import jwtDecode from 'jwt-decode';
import { Cookies } from 'react-cookie';
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {setSession} from "../redux/auth/saga";
import * as CryptoJS from 'crypto-js'

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    if (!user) {
        return false;
    }
    const decoded = jwtDecode(user.token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
        setSession(null);
        return false;
    } else {
        return true;
    }
};

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {

    const cookies = new Cookies();
    const rawUser = cookies.get('user', { path: '/' });
    const rawCompanyData = cookies.get('company', { path: '/' });

    if (!rawUser || !rawCompanyData) {
        return null;
    }

    const decryptedUser = decryptMe(rawUser);
    const decryptedCompanyData = decryptMe(rawCompanyData);

    const user = decryptedUser ? (typeof decryptedUser == 'object' ? decryptedUser : JSON.parse(decryptedUser)) : null;

    let companyData = null;

    if (decryptedCompanyData) {
        if (typeof decryptedCompanyData === 'object') {
            companyData = decryptedCompanyData;
        } else {
            try {
                companyData = JSON.parse(decryptedCompanyData);
            } catch {
                companyData = { company: decryptedCompanyData };
            }
        }
    }

    if (companyData) {
        for (const property in companyData) {
            if (Object.hasOwn(companyData, property)) {
                user[property] = companyData[property];
            }
        }
    }

    try {
        user.managedCompanies = JSON.parse(localStorage.getItem('managedCompanies'));
    } catch {
        user.managedCompanies = [];
    }

    if (user) {
        if (user.colorMain) { document.documentElement.style.setProperty('--color1',user.colorMain); }
        if (user.colorSecondary) { document.documentElement.style.setProperty('--color2',user.colorSecondary); }
        if (user.colorBackground) { document.documentElement.style.setProperty('--color3',user.colorBackground); }
        if (user.colorComplementary) { document.documentElement.style.setProperty('--color4',user.colorComplementary); }
    }

    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

const updateUserField = (field,value) => {

    const cookies = new Cookies();
    const rawUser = cookies.get('user', { path: '/' });

    if (!rawUser) {
        return null;
    }

    const decryptedUser = decryptMe(rawUser);
    const user = decryptedUser ? (typeof decryptedUser == 'object' ? decryptedUser : JSON.parse(decryptedUser)) : null;

    user[field] = value;

    cookies.set('user', encryptMe(JSON.stringify(user)), {path: '/'});

}

const updateCompanyTheme = (values) => {

    const cookies = new Cookies();
    const rawCompanyData = cookies.get('company', { path: '/' });

    if (!rawCompanyData) {
        return null;
    }

    const decryptedCompanyData = decryptMe(rawCompanyData);
    const companyData = decryptedCompanyData ? (typeof decryptedCompanyData == 'object' ? decryptedCompanyData : JSON.parse(decryptedCompanyData)) : null;

    companyData.colorMain = values.colorMain;
    companyData.colorSecondary = values.colorSecondary;
    companyData.colorComplementary = values.colorComplementary;
    companyData.colorBackground = values.colorBackground;

    cookies.set('company', encryptMe(JSON.stringify(companyData)), {path: '/'});
}

const isWorkerDisabled = (loggedInUser) => {
    return (
        loggedInUser.isActive !== 1 || loggedInUser.isDeleted === 1 || loggedInUser.isUnsubscribed
    );
};

const isWorkerDisabledPath = (path) => {
    let paths = ['/','/dashboard','/cards','/user/profile','/user/password','/account/logout'];
    return paths.indexOf(path) !== -1;
};

const LoginButton = () => {
    const { loginWithRedirect } = useAuth0();

    return <button onClick={() => loginWithRedirect()}>Log In</button>;
};

const LiveLoginButton = () => {
    return <a className={'btn btn-primary'} href={'https://dev-kf34fjcd6n7ivpu4.eu.auth0.com/samlp/evi0ZOM6DaUHdkKqzaN8lYeH08JLADmM?connection=windowslive'}
              >Log In Live</a>;
};

const LogoutButton = () => {
    const { logout } = useAuth0();

    return (
        <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
            Log Out
        </button>
    );
};

const Profile = () => {
    const { user, isAuthenticated, isLoading } = useAuth0();

    if (!isAuthenticated) {
        return <div>NO</div>;
    }

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    return (
        isAuthenticated && (
            <div>
                <img src={user.picture} alt={user.name} />
                <h2>{user.name}</h2>
                <p>{user.email}</p>
            </div>
        )
    );
};

const secretKey = process.env.REACT_APP_SECRET_KEY;

const encryptMe = (string) => {
    return string ? CryptoJS.AES.encrypt(string, secretKey).toString() : '';
}

const decryptMe = (string) => {
    if (!string) {
        return null;
    }
    try {
        const bytes = CryptoJS.AES.decrypt(string, secretKey )
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        return null;
    }
}

export { isUserAuthenticated, getLoggedInUser, isWorkerDisabled, isWorkerDisabledPath, updateCompanyTheme,
    LiveLoginButton, LoginButton, LogoutButton, Profile,
    updateUserField, encryptMe, decryptMe };
